'use client';

import { BaseModalContent, Modal } from '@/components/modal';
import { useJoinFormStore } from '@/stores/join-form-store/join-form-store';

import { Button } from '../button';
import { MODAL_NAMES } from '@/constants'

type Props = {
    onClearAddress: () => void;
};

export const ChangeAddressModal = ({ onClearAddress }: Props) => {
    const { closeModal, getCurrentModal } = useJoinFormStore();
    const currentModal = getCurrentModal();

    return (
        <Modal
            heading="Are you sure you want to change address?"
            description="Changing the address will remove energy plans you have already compared and selected."
            isModalOpen={currentModal === MODAL_NAMES.ChangeAddressWarning}
        >
            <BaseModalContent
                buttonComponent={
                    <>
                        <Button
                            variant="primary"
                            onClick={() => {
                                onClearAddress();
                                closeModal(MODAL_NAMES.ChangeAddressWarning);
                            }}
                        >
                            Enter another address
                        </Button>
                        <Button
                            variant="tertiary"
                            onClick={() => {
                                closeModal(MODAL_NAMES.ChangeAddressWarning);
                            }}
                        >
                            Keep selected plans
                        </Button>
                    </>
                }
            />
        </Modal>
    );
};
